/* RESPONSIBLE TEAM: team-actions */
import Model, { attr } from '@ember-data/model';

export default class InstallationEvents extends Model {
  @attr() report;
}
